import React from 'react';
import styles from "./Inbox.module.css";
import { useUser } from "@clerk/clerk-react";

const notifications = [
  { id: 1, type: 'alert', message: 'You have spent 80% of your Food budget.', time: '2 mins ago', icon: '⚠️' },
  { id: 2, type: 'success', message: 'Successfully added "Grocery" expense.', time: '1 hour ago', icon: '✅' },
  { id: 3, type: 'info', message: 'Monthly report for March is ready.', time: '5 hours ago', icon: '📊' },
];

export default function Inbox() {
  const { user } = useUser();

  return (
    <div className={styles.InboxContainer}>
      <div className={styles.Header}>
        <h2>Notifications</h2>
        <span>Hello, {user?.firstName}</span>
      </div>
      
      <div className={styles.List}>
        {notifications.map((notif) => (
          <div key={notif.id} className={styles.NotificationCard}>
            <div className={styles.IconBox}>{notif.icon}</div>
            <div className={styles.Content}>
              <p className={styles.Message}>{notif.message}</p>
              <span className={styles.Time}>{notif.time}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}